import OffersListV2 from './OffersListV2';

export default OffersListV2;
